// removed by extract-text-webpack-plugin
module.exports = {"CssPlayground":"_3e0uOIrK","perspective":"Jb3pltxS","multiPerspective":"_2w-s7iw1","PerspectiveBox":"_3TyfVk9M","translateZ":"PSmMrXEw","box":"_22w1KTif","flipContainer":"_3aeWR8fQ","card":"_3vnhnkco","rightCenter":"_2aWtyhte","leftCenter":"_1Q56F5PC","multi":"_3MM9OVTq","front":"_2_5XXhtE","back":"_12NzfkTh","cubeContainer":"_2u9lLi1L","cube":"lPr4wrcL","face":"_1CTFqXo8","right":"_1kDVm96b","left":"_2UPunlc5","top":"glyUQM7m","bottom":"_30MXCPO3"};


//////////////////
// WEBPACK FOOTER
// ./client/components/CssPlayground.styl
// module id = 294
// module chunks = 0